import { Box, Stack, Typography, styled, Divider } from "@mui/material";
import React from "react";
import { ButtonPrimary } from "src/UI/ButtonPrimary";
import { ButtonSecondary } from "src/UI/ButtonSecondary";

type Props = {
  title: string;
  subtitle: string;
  actions: {
    variant: "outlined" | "contained";
    startIcon?: React.ReactNode;
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }[];
};

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "8px",
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "end",
  },
}));

export default function SectionHeader({ title, subtitle, actions }: Props) {
  return (
    <>
      <Wrapper>
        <Stack direction="column" sx={{ lineHeight: "1" }} spacing="4px">
          <Typography fontWeight={600} fontSize={20} gutterBottom>
            {title}
          </Typography>
          <Typography>{subtitle}</Typography>
        </Stack>
        <Stack
          direction="row"
          spacing="12px"
          sx={{
            width: { xs: "100%", sm: "auto" },
            "& > *": { flex: { xs: 1, sm: "initial" } },
          }}
        >
          {actions.map((action, index) => {
            const Tag =
              action.variant === "contained" ? ButtonPrimary : ButtonSecondary;
            return (
              <Tag
                key={index}
                size="md"
                onClick={action.onClick}
                startIcon={action.startIcon}
                disabled={action.disabled}
              >
                {action.label}
              </Tag>
            );
          })}
        </Stack>
      </Wrapper>
      <Divider sx={{ marginBlock: "24px" }} />
    </>
  );
}
